import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Store } from '@ngrx/store';

import { SettingsManagementService } from 'src/app/core/services/system-services/settings-management.service';
import * as settings from 'src/app/store/settings';

@Component({
  selector: 'smart-settings-shortcut',
  templateUrl: './settings-shortcut.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SettingsShortcutComponent {

  constructor(private store: Store<any>, private settingService: SettingsManagementService) { }

  toggleHideNavigation($event: MouseEvent) {
    $event.preventDefault();
    this.store.dispatch(settings.toggleHideNavigation());
  }

  toggleMinifyNavigation($event: MouseEvent) {
    $event.preventDefault();
    const minifyState = this.settingService.getNavBarMinifyState()
    this.store.dispatch(settings.toggleMinifyNavigation({ minifyNavigation: !minifyState }));
  }

  toggleFixedNavigation($event: MouseEvent) {
    $event.preventDefault();
    this.store.dispatch(settings.toggleFixedNavigation());
  }
}
